import { of, tap, timer } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
// Utils
import { formFlattenedParamString } from 'NewAngular/utils/urls';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Interfaces / types / enums
import { CustomPDFReportType } from '../enums/custom-pdf-report-type.enum';
import { ReportNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/naming-convention.enum';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class CustomPDFReportModulePreviewImageService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.cache = {};
        // 3 minutes in milliseconds in case preview images contain intraday data
        this.ttl = 3 * 60 * 1000;
    }
    getPDFReportModulePreviewImage(reportType, params) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PREVIEW_IMAGE, {
            reportType,
        });
        // Combinations of module type, preview securities, naming convention, custom labels, and field values will have the same preview image
        // for a user until the TTL expires, so we can create a cache key from those 5 things.
        const cacheKey = `${params.module_type}_${params.naming_convention ?? ReportNamingConvention.TRUNCATED}
            _${(params.custom_labels ?? []).join(',')}_${params.security_ids.join(',')}_${formFlattenedParamString(params.customizable_fields, Object.keys(params.customizable_fields).sort())}`;
        // If we have image data in the cache then return it
        if (this.cache[cacheKey]?.data.imageUrls.length) {
            return of(this.cache[cacheKey].data);
        }
        // If a request is already in progress for the cache key then return the observable
        if (this.cache[cacheKey]?.observable) {
            return this.cache[cacheKey].observable;
        }
        // Otherwise, fetch new image data
        const observable = this.ajaxService
            .postJsonDataObserveBody(url, params)
            .pipe(shareReplay(1));
        this.cache[cacheKey] = {
            data: { imageUrls: [], warning: '' },
            observable,
        };
        return observable.pipe(tap((response) => {
            this.cache[cacheKey] = {
                data: response,
                observable: null,
            };
            // Evict from image cache after the TTL has passed
            timer(this.ttl).subscribe(() => {
                delete this.cache[cacheKey];
            });
        }));
    }
    getPDFReportModuleProposalsWarningMessage(talkingPoint, reportId = null) {
        return this.getPDFReportModulePreviewImage(CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW, {
            security_ids: [],
            report_id: reportId,
            customizable_fields: {
                select_talking_points: true,
                module_title: 'Proposal',
                talking_points: [talkingPoint],
            },
            naming_convention: ReportNamingConvention.TRUNCATED,
            custom_labels: [],
            module_type: 'HALF_PAGE_PROPOSAL_PORTRAIT_MODULE',
            report_orientation: CustomPDFReportOrientation.PORTRAIT,
        });
    }
    getTalkingPointPreviewImage(securityIds, talkingPoint, includeBenchmark) {
        const params = {
            security_ids: securityIds.filter((_) => _),
            talking_point: talkingPoint,
            include_benchmark: includeBenchmark,
        };
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.CUSTOM_PDF_REPORTS.TALKING_POINT_PREVIEW_IMAGE, params);
    }
}
CustomPDFReportModulePreviewImageService.ɵfac = function CustomPDFReportModulePreviewImageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPDFReportModulePreviewImageService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
CustomPDFReportModulePreviewImageService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CustomPDFReportModulePreviewImageService, factory: CustomPDFReportModulePreviewImageService.ɵfac, providedIn: 'root' });
